import {defineStore} from "pinia";

export const useDataSelectStore = defineStore('dataSelect', {
    state: () => ({
        dataSelect: {},
        dataSelects: [],
        dataSelectsSelect: {
            "PHYSICIAN_CATEGORY": [],
            "PHARMACY_CATEGORY": [],
            "WHOLESALER_CATEGORY": [],
            "CUSTOMER_SPECIALTY": [],
            "CUSTOMER_TITLE": [],
            "CUSTOMER_LEADER": [],
            "CUSTOMER_POTENTIAL": [],
            "CUSTOMER_DOCTOR_TYPE": [],
            "CUSTOMER_CLIENT_TYPE": [],
            "CUSTOMER_AGREEMENT": [],
            "CUSTOMER_COOPERATION_LEVEL": [],

            "ADDRESS_CLASS": [],
            "ADDRESS_SPECIALITY_SERVICE": [],

            "DELEGATE_LABORATORY": [],
            "DELEGATE_REGION": [],
            "DELEGATE_PATRONYM": [],
            "DELEGATE_GRADE": [],

            "PRODUCT_RANGE": [],

            "VISIT_TYPE": [],
            "VISIT_LOYALTY_STATUS": [],
            "VISIT_PRESCRIBER_CLASS": [],
        },
    }),
    actions: {
        setDataSelect(dataSelect) {
            this.dataSelect = dataSelect
        },
        setDataSelectsSelect(dataSelectsSelect, type) {
            this.dataSelectsSelect[type] = dataSelectsSelect;
        },
        addDataSelectsSelect(dataSelectSelect, type) {
            if (!this.dataSelectsSelect[type])
                this.dataSelectsSelect[type] = [];
            this.dataSelectsSelect[type].unshift(dataSelectSelect);
        },
        setDataSelects(dataSelects) {
            this.dataSelects = dataSelects
        },
        addDataSelect(dataSelect) {
            this.dataSelects.unshift(dataSelect)
        },
        updateDataSelect(dataSelect) {
            let index = this.dataSelects.findIndex(cl => cl.id === dataSelect.id)
            this.dataSelects.splice(index, 1, dataSelect)
        },
        deleteDataSelect(dataSelect) {
            let index = this.dataSelects.findIndex(cl => cl.id === dataSelect.id)
            this.dataSelects.splice(index, 1)
        },
    },
});